import { render } from "./SkillCards.vue?vue&type=template&id=5676b7ac"
import script from "./SkillCards.vue?vue&type=script&lang=js"
export * from "./SkillCards.vue?vue&type=script&lang=js"
script.render = render

export default script